"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
exports.parse = exports.BasicJQL = void 0;
var jql_ast_1 = require("@atlassiansox/jql-ast");
var BasicJQLVisitor = /** @class */ (function () {
    function BasicJQLVisitor(onBehalfOf, fields) {
        var _this = this;
        this.onBehalfOf = onBehalfOf;
        this.fields = fields;
        this.simple = true;
        this.setAdvanced = function (why) {
            _this.simple = false;
            if (!_this.why) {
                _this.why = why;
            }
        };
        this.visitOrderBy = function (orderBy) {
            orderBy.fields.forEach(function (f) { return f.accept(_this); });
        };
        this.visitFieldValueOperator = function (op) {
            return;
        };
        this.inConjunction = false;
        this.inDisjunction = false;
        this.disjunctionOver = undefined;
        this.conjuncts = {};
        this.visitFieldValueClause = function (fv) {
            var f = _this.fields(fv.field.name);
            if (!f) {
                _this.setAdvanced("field " + fv.field.name + " is not known");
                return;
            }
            if (_this.inDisjunction) {
                if (_this.disjunctionOver) {
                    if (_this.disjunctionOver.key !== f.key) {
                        _this.setAdvanced("unsupported OR across different fields");
                        return;
                    }
                }
                else {
                    _this.disjunctionOver = f;
                }
            }
            if (!fv.operator) {
                _this.setAdvanced("unsupported lack of operator");
                return;
            }
            var multiValue = false;
            if (fv.operator.value === jql_ast_1.FIELD_OPERATOR_IN) {
                multiValue = true;
            }
            else if (fv.operator.value !== jql_ast_1.FIELD_OPERATOR_EQUALS) {
                _this.setAdvanced("unsupported operator \"" + fv.operator.value + "\"");
                return;
            }
            var con = _this.conjuncts[f.key] || { field: f, disjuncts: [] };
            _this.conjuncts[f.key] = con; // there's probably JS shorthand for this getorset
            if (!fv.operand) {
                _this.setAdvanced("unsupported form of field value clause");
                return;
            }
            if (!multiValue) {
                if (fv.operand.operandType !== jql_ast_1.OPERAND_TYPE_FIELD_VALUE) {
                    // console.log(`no likey ${JSON.stringify(fv.operand)}`);
                    _this.setAdvanced("unsupported form of field value operand for \"=\" operator");
                    return;
                }
                con.disjuncts.push(fv.operand);
            }
            else {
                if (fv.operand.operandType !== jql_ast_1.OPERAND_TYPE_LIST) {
                    // console.log(`no likey ${JSON.stringify(fv.operand)}`);
                    _this.setAdvanced("unsupported form of field value operand for IN operator");
                    return;
                }
                fv.operand.values.forEach(function (unitaryOperand) {
                    if (unitaryOperand.operandType !== jql_ast_1.OPERAND_TYPE_FIELD_VALUE) {
                        _this.setAdvanced("unsupported operand type in list");
                        return;
                    }
                    con.disjuncts.push(unitaryOperand);
                });
            }
        };
        this.visitCompoundClause = function (clause) {
            if (clause.operator.value === jql_ast_1.COMPOUND_CLAUSE_AND) {
                if (_this.inConjunction || _this.inDisjunction) {
                    _this.setAdvanced('unsupported nesting of AND and OR clauses');
                    return;
                }
                _this.inConjunction = true;
            }
            else if (clause.operator.value === jql_ast_1.COMPOUND_CLAUSE_OR) {
                if (_this.inDisjunction) {
                    _this.setAdvanced('unsupported nesting of OR within OR');
                    return;
                }
                _this.inDisjunction = true;
                _this.disjunctionOver = undefined;
            }
            clause.clauses.forEach(function (c) { return c.accept(_this); });
        };
        this.visitOrderByField = function (orderByField) {
            // console.log("visit ORDER BY field", orderByField);
            var f = _this.fields(orderByField.field.name);
            if (!f) {
                _this.setAdvanced("field \"" + orderByField.field.name + "\" is not known");
                return;
            }
            var dir = f.defaultSortOrder;
            if (orderByField.direction) {
                if (orderByField.direction.value === jql_ast_1.ORDER_BY_DIRECTION_DESC) {
                    dir = 'DESC';
                }
                else if (orderByField.direction.value === jql_ast_1.ORDER_BY_DIRECTION_ASC) {
                    dir = 'ASC';
                }
            }
            _this.onBehalfOf.sorts.push({
                field: f,
                direction: dir
            });
        };
        this.visitQuery = function (node) {
            if (node.orderBy) {
                node.orderBy.accept(_this);
            }
            if (node.where) {
                node.where.accept(_this);
            }
        };
        this.visitNode = function (node) {
            return;
            // console.log(`fallback ${JSON.stringify(node)}`);
        };
    }
    return BasicJQLVisitor;
}());
function jqlNameForField(f) {
    // some might be weird, like cf[10003] instead of customfield_10003,
    // so the key might not match the name
    return f.key;
}
function jqlQuotedValue(value) {
    return value.value;
}
function jqlForFilter(f) {
    if (f.disjuncts.length > 1) {
        var parts_1 = [jqlNameForField(f.field), ' IN ('];
        parts_1.push(jqlQuotedValue(f.disjuncts[0]));
        f.disjuncts.slice(1).forEach(function (v) {
            parts_1.push(', ');
            parts_1.push(jqlQuotedValue(v));
        });
        parts_1.push(')');
        return parts_1;
    }
    else {
        return [jqlNameForField(f.field), ' = ', jqlQuotedValue(f.disjuncts[0])];
    }
}
var BasicJQL = /** @class */ (function () {
    function BasicJQL(sorts) {
        if (sorts === void 0) { sorts = []; }
        this.sorts = sorts;
        this.filters = {};
        // sorts: Sort[] = [];
        this.valid = false;
    }
    BasicJQL.prototype.setFromJQL = function (jql, fields) {
        var ast = new jql_ast_1.JastBuilder().build(jql);
        var visitor = new BasicJQLVisitor(this, fields);
        var q = ast.query;
        if (q) {
            q.accept(visitor);
            if (visitor.simple) {
                this.valid = true;
                this.filters = visitor.conjuncts;
            }
            else {
                throw new Error("JQL is not basic, and this is why: " + visitor.why);
            }
        }
        else {
            throw new Error("JQL is not basic, we can't even parse it");
        }
    };
    BasicJQL.prototype.JQL = function () {
        return this.toString();
    };
    BasicJQL.prototype.toString = function () {
        var _this = this;
        var fragments = [];
        var anyfilter = false;
        Object.keys(this.filters).forEach(function (key) {
            var f = _this.filters[key];
            if (anyfilter) {
                fragments.push(' AND ');
            }
            fragments = __spreadArrays(fragments, jqlForFilter(f));
            anyfilter = true;
        });
        if (this.sorts.length > 0) {
            if (anyfilter) {
                fragments.push(' ');
            }
            fragments.push('ORDER BY ');
            var anysort_1 = false;
            this.sorts.forEach(function (s) {
                if (anysort_1) {
                    fragments.push(', ');
                }
                fragments.push(jqlNameForField(s.field));
                if (s.direction === 'DESC') {
                    fragments.push(' DESC');
                }
                else {
                    fragments.push(' ASC');
                }
                anysort_1 = true;
            });
        }
        return fragments.join('');
    };
    return BasicJQL;
}());
exports.BasicJQL = BasicJQL;
exports.parse = function (jql, fields) {
    var b = new BasicJQL();
    try {
        b.setFromJQL(jql, fields);
        return b;
    }
    catch (_a) {
        return undefined;
    }
};
//# sourceMappingURL=index.js.map